// extracted by mini-css-extract-plugin
export var closeButton = "_kb-1";
export var closeX = "_kb-3";
export var container = "_kb-0";
export var image = "_kb-2";